export default __webpack_public_path__ + "static/webpage-f0e8cf2a04d7b8aea4751972ca50d2ea.webp";